import { Box } from "@mui/material";
import type { PropsWithChildren } from "react";

import { AppStatusOverlay } from "./AppStatusOverlay";
import { GlobalNotifier } from "@/components/Organisms/GlobalNotifier";

export default function MainLayout({ children }: PropsWithChildren) {
  return (
    <Box>
      {children}
      <AppStatusOverlay />
      <GlobalNotifier />
    </Box>
  );
}
